import { render } from "./App.vue?vue&type=template&id=f014be8c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\reimo\\Documents\\Projektide IT osa\\AccountaBuddy\\accounta-buddy-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__